import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import { getWeekLabel } from './calendar'

const routes = [
  { path: '/week/:week/:task?', component: require('./pages/Traffic').default, name: 'traffic' },
  { path: '/profile', component: require('./pages/Profile').default },
  { path: '/vacations', component: require('./pages/Vacations').default },
  { path: '/clients', component: require('./pages/Clients').default },
  { path: '/departments', component: require('./pages/Departments').default },
  { path: '/users', component: require('./pages/Users').default },
  { path: '/export', component: require('./pages/Export').default },
  // { path: '/',            component: require('./pages/Dashboard').default },
  // { path: '/mottos/:id?', component: require('./pages/Mottos').default, name: 'mottos' },
  { path: '*', component: require('./pages/NotFound').default },
]

const parts = document.location.pathname.split('/')
while(parts.length > 1) parts.pop()

const router = new VueRouter({
  base: parts.join('/'),
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if(to.path == '/' && !to.name) {
    return next('/week/'+getWeekLabel(router.app.$store.getters.now))
  }
  if(to.name || router.app.$store.getters['auth/hasRoute'](to)) return next()
  return next('/')
})

export default router

const getRouter = () => router
export {
  getRouter
}
